var map = {
	"./Aircraft/Airliner_Black.png": 56,
	"./Aircraft/Airliner_Blue.png": 1096,
	"./Aircraft/Airliner_Green.png": 1097,
	"./Aircraft/Airliner_Grey.png": 1098,
	"./Aircraft/Airliner_Red.png": 1099,
	"./Aircraft/Airliner_Yellow.png": 1100,
	"./Aircraft/Airplane_Black.png": 1101,
	"./Aircraft/Airplane_Blue.png": 1102,
	"./Aircraft/Airplane_Green.png": 1103,
	"./Aircraft/Airplane_Grey.png": 1104,
	"./Aircraft/Airplane_Red.png": 1105,
	"./Aircraft/Airplane_Yellow.png": 1106,
	"./Aircraft/Helicopter_Black.png": 1107,
	"./Aircraft/Helicopter_Blue.png": 1108,
	"./Aircraft/Helicopter_Green.png": 1109,
	"./Aircraft/Helicopter_Grey.png": 1110,
	"./Aircraft/Helicopter_Red.png": 1111,
	"./Aircraft/Helicopter_Yellow.png": 1112,
	"./Arrows/093-chevron-1.png": 1113,
	"./Arrows/093-chevron-10.png": 1114,
	"./Arrows/093-chevron-11.png": 1115,
	"./Arrows/093-chevron-2.png": 1116,
	"./Arrows/093-chevron-3.png": 1117,
	"./Arrows/093-chevron-4.png": 1118,
	"./Arrows/093-chevron-5.png": 1119,
	"./Arrows/093-chevron-6.png": 1120,
	"./Arrows/093-chevron-7.png": 1121,
	"./Arrows/093-chevron-8.png": 1122,
	"./Arrows/093-chevron-9.png": 1123,
	"./Arrows/093-chevron.png": 1124,
	"./Arrows/093-compress-1.png": 1125,
	"./Arrows/093-compress.png": 1126,
	"./Arrows/093-curved-arrow-1.png": 1127,
	"./Arrows/093-curved-arrow-2.png": 1128,
	"./Arrows/093-curved-arrow-3.png": 1129,
	"./Arrows/093-curved-arrow.png": 1130,
	"./Arrows/093-diagonal-arrow-1.png": 1131,
	"./Arrows/093-diagonal-arrow-10.png": 1132,
	"./Arrows/093-diagonal-arrow-11.png": 1133,
	"./Arrows/093-diagonal-arrow-12.png": 1134,
	"./Arrows/093-diagonal-arrow-13.png": 1135,
	"./Arrows/093-diagonal-arrow-14.png": 1136,
	"./Arrows/093-diagonal-arrow-15.png": 1137,
	"./Arrows/093-diagonal-arrow-2.png": 1138,
	"./Arrows/093-diagonal-arrow-3.png": 1139,
	"./Arrows/093-diagonal-arrow-4.png": 1140,
	"./Arrows/093-diagonal-arrow-5.png": 1141,
	"./Arrows/093-diagonal-arrow-6.png": 1142,
	"./Arrows/093-diagonal-arrow-7.png": 1143,
	"./Arrows/093-diagonal-arrow-8.png": 1144,
	"./Arrows/093-diagonal-arrow-9.png": 1145,
	"./Arrows/093-diagonal-arrow.png": 1146,
	"./Arrows/093-down-arrow-1.png": 1147,
	"./Arrows/093-down-arrow-2.png": 1148,
	"./Arrows/093-down-arrow-3.png": 1149,
	"./Arrows/093-down-arrow-4.png": 1150,
	"./Arrows/093-down-arrow-5.png": 1151,
	"./Arrows/093-down-arrow.png": 1152,
	"./Arrows/093-exchange-1.png": 1153,
	"./Arrows/093-exchange.png": 1154,
	"./Arrows/093-expand-1.png": 1155,
	"./Arrows/093-expand-2.png": 1156,
	"./Arrows/093-expand-3.png": 1157,
	"./Arrows/093-expand.png": 1158,
	"./Arrows/093-left-arrow-1.png": 1159,
	"./Arrows/093-left-arrow-2.png": 1160,
	"./Arrows/093-left-arrow-3.png": 1161,
	"./Arrows/093-left-arrow-4.png": 1162,
	"./Arrows/093-left-arrow-5.png": 1163,
	"./Arrows/093-left-arrow-6.png": 1164,
	"./Arrows/093-left-arrow.png": 1165,
	"./Arrows/093-move-1.png": 1166,
	"./Arrows/093-move.png": 1167,
	"./Arrows/093-redo-1.png": 1168,
	"./Arrows/093-redo.png": 1169,
	"./Arrows/093-resize-1.png": 1170,
	"./Arrows/093-resize-2.png": 1171,
	"./Arrows/093-resize-3.png": 1172,
	"./Arrows/093-resize.png": 1173,
	"./Arrows/093-right-arrow-1.png": 1174,
	"./Arrows/093-right-arrow-2.png": 1175,
	"./Arrows/093-right-arrow-3.png": 1176,
	"./Arrows/093-right-arrow-4.png": 1177,
	"./Arrows/093-right-arrow-5.png": 1178,
	"./Arrows/093-right-arrow-6.png": 1179,
	"./Arrows/093-right-arrow-7.png": 1180,
	"./Arrows/093-right-arrow.png": 1181,
	"./Arrows/093-scroll-1.png": 1182,
	"./Arrows/093-scroll.png": 1183,
	"./Arrows/093-sort-1.png": 1184,
	"./Arrows/093-sort-2.png": 1185,
	"./Arrows/093-sort-3.png": 1186,
	"./Arrows/093-sort.png": 1187,
	"./Arrows/093-turn-left-1.png": 1188,
	"./Arrows/093-turn-left-2.png": 1189,
	"./Arrows/093-turn-left-3.png": 1190,
	"./Arrows/093-turn-left.png": 1191,
	"./Arrows/093-turn-right-1.png": 1192,
	"./Arrows/093-turn-right-2.png": 1193,
	"./Arrows/093-turn-right-3.png": 1194,
	"./Arrows/093-turn-right.png": 1195,
	"./Arrows/093-undo-1.png": 1196,
	"./Arrows/093-undo.png": 1197,
	"./Arrows/093-up-arrow-1.png": 1198,
	"./Arrows/093-up-arrow-2.png": 1199,
	"./Arrows/093-up-arrow-3.png": 1200,
	"./Arrows/093-up-arrow-4.png": 1201,
	"./Arrows/093-up-arrow-5.png": 1202,
	"./Arrows/093-up-arrow-6.png": 1203,
	"./Arrows/093-up-arrow.png": 1204,
	"./Assets/151-actions.png": 1205,
	"./Assets/151-advert.png": 1206,
	"./Assets/151-antennas.png": 1207,
	"./Assets/151-archives.png": 1208,
	"./Assets/151-attached.png": 1209,
	"./Assets/151-banker.png": 1210,
	"./Assets/151-barrow.png": 1211,
	"./Assets/151-bed-side.png": 1212,
	"./Assets/151-beds.png": 1213,
	"./Assets/151-blackboard.png": 1214,
	"./Assets/151-blocked.png": 1215,
	"./Assets/151-book-bag-1.png": 1216,
	"./Assets/151-book-bag.png": 1217,
	"./Assets/151-bridges.png": 1218,
	"./Assets/151-calculations.png": 1219,
	"./Assets/151-carrier.png": 1220,
	"./Assets/151-ceremonial.png": 1221,
	"./Assets/151-chairs.png": 1222,
	"./Assets/151-cleaned.png": 1223,
	"./Assets/151-closing.png": 1224,
	"./Assets/151-cooling.png": 1225,
	"./Assets/151-demostration.png": 1226,
	"./Assets/151-deposit.png": 1227,
	"./Assets/151-dialogue.png": 1228,
	"./Assets/151-disturbance.png": 1229,
	"./Assets/151-domestic-phone.png": 1230,
	"./Assets/151-door-key.png": 1231,
	"./Assets/151-door.png": 1232,
	"./Assets/151-doorway.png": 1233,
	"./Assets/151-draws.png": 1234,
	"./Assets/151-driller.png": 1235,
	"./Assets/151-electric-1.png": 1236,
	"./Assets/151-electric-2.png": 1237,
	"./Assets/151-electric.png": 1238,
	"./Assets/151-entrance.png": 1239,
	"./Assets/151-facade-1.png": 1240,
	"./Assets/151-facade.png": 1241,
	"./Assets/151-fader.png": 1242,
	"./Assets/151-file-storage.png": 1243,
	"./Assets/151-fireplace-1.png": 1244,
	"./Assets/151-fireplace.png": 1245,
	"./Assets/151-flats-1.png": 1246,
	"./Assets/151-flats.png": 1247,
	"./Assets/151-frame.png": 1248,
	"./Assets/151-garden-work.png": 1249,
	"./Assets/151-gardener.png": 1250,
	"./Assets/151-gardening.png": 1251,
	"./Assets/151-glamour.png": 1252,
	"./Assets/151-graphic-design.png": 1253,
	"./Assets/151-graphs.png": 1254,
	"./Assets/151-hacksaw.png": 1255,
	"./Assets/151-hand-gesture.png": 1256,
	"./Assets/151-hand-phones.png": 1257,
	"./Assets/151-headphones.png": 1258,
	"./Assets/151-health-care.png": 1259,
	"./Assets/151-hearth.png": 1260,
	"./Assets/151-house-things-1.png": 1261,
	"./Assets/151-house-things-2.png": 1262,
	"./Assets/151-house-things.png": 1263,
	"./Assets/151-house.png": 1264,
	"./Assets/151-houses.png": 1265,
	"./Assets/151-indoor.png": 1266,
	"./Assets/151-industrial-park.png": 1267,
	"./Assets/151-industrial.png": 1268,
	"./Assets/151-interior-design.png": 1269,
	"./Assets/151-invention.png": 1270,
	"./Assets/151-keyword.png": 1271,
	"./Assets/151-kilograms.png": 1272,
	"./Assets/151-ladders.png": 1273,
	"./Assets/151-line-chart.png": 1274,
	"./Assets/151-lover.png": 1275,
	"./Assets/151-mail.png": 1276,
	"./Assets/151-mailed.png": 1277,
	"./Assets/151-mallet.png": 1278,
	"./Assets/151-mansory.png": 1279,
	"./Assets/151-maps-and-flags-1.png": 1280,
	"./Assets/151-maps-and-flags-2.png": 1281,
	"./Assets/151-maps-and-flags-3.png": 1282,
	"./Assets/151-maps-and-flags-4.png": 1283,
	"./Assets/151-maps-and-flags-5.png": 1284,
	"./Assets/151-maps-and-flags-6.png": 1285,
	"./Assets/151-maps-and-flags.png": 1286,
	"./Assets/151-measuring-1.png": 1287,
	"./Assets/151-measuring.png": 1288,
	"./Assets/151-mechanics.png": 1289,
	"./Assets/151-metallic-blind.png": 1290,
	"./Assets/151-money-icons.png": 1291,
	"./Assets/151-monumental.png": 1292,
	"./Assets/151-motorhome.png": 1293,
	"./Assets/151-online-store.png": 1294,
	"./Assets/151-packaging.png": 1295,
	"./Assets/151-paint-roller.png": 1296,
	"./Assets/151-painted.png": 1297,
	"./Assets/151-paper-printer.png": 1298,
	"./Assets/151-paper-work.png": 1299,
	"./Assets/151-picket.png": 1300,
	"./Assets/151-pincers.png": 1301,
	"./Assets/151-plan.png": 1302,
	"./Assets/151-plans.png": 1303,
	"./Assets/151-plumbering-1.png": 1304,
	"./Assets/151-plumbering.png": 1305,
	"./Assets/151-printed.png": 1306,
	"./Assets/151-property.png": 1307,
	"./Assets/151-pruners.png": 1308,
	"./Assets/151-purses.png": 1309,
	"./Assets/151-radiators.png": 1310,
	"./Assets/151-reading-glasses.png": 1311,
	"./Assets/151-real-estate-1.png": 1312,
	"./Assets/151-real-estate-2.png": 1313,
	"./Assets/151-real-estate-3.png": 1314,
	"./Assets/151-real-estate-4.png": 1315,
	"./Assets/151-real-estate-5.png": 1316,
	"./Assets/151-real-estate-6.png": 1317,
	"./Assets/151-real-estate.png": 1318,
	"./Assets/151-relax.png": 1319,
	"./Assets/151-religious.png": 1320,
	"./Assets/151-rent.png": 1321,
	"./Assets/151-reparation.png": 1322,
	"./Assets/151-roof.png": 1323,
	"./Assets/151-sand-clock.png": 1324,
	"./Assets/151-savings.png": 1325,
	"./Assets/151-security-system-1.png": 1326,
	"./Assets/151-security-system.png": 1327,
	"./Assets/151-seventeen.png": 1328,
	"./Assets/151-shower.png": 1329,
	"./Assets/151-single.png": 1330,
	"./Assets/151-sit-down.png": 1331,
	"./Assets/151-skyline.png": 1332,
	"./Assets/151-step-ladder.png": 1333,
	"./Assets/151-storehouse.png": 1334,
	"./Assets/151-studying.png": 1335,
	"./Assets/151-switch-off.png": 1336,
	"./Assets/151-text-file.png": 1337,
	"./Assets/151-title.png": 1338,
	"./Assets/151-tools-and-utensils.png": 1339,
	"./Assets/151-transportation.png": 1340,
	"./Assets/151-trees.png": 1341,
	"./Assets/151-trucks-1.png": 1342,
	"./Assets/151-trucks.png": 1343,
	"./Assets/151-turned-off.png": 1344,
	"./Assets/151-up-1.png": 1345,
	"./Assets/151-up-2.png": 1346,
	"./Assets/151-up.png": 1347,
	"./Assets/151-ventilation.png": 1348,
	"./Assets/151-wc.png": 1349,
	"./Assets/151-wheel-chair.png": 1350,
	"./Assets/151-wheelbarrow.png": 1351,
	"./Assets/151-winch.png": 1352,
	"./Assets/151-work-tools.png": 1353,
	"./Assets/151-worker.png": 1354,
	"./Bikes/Bicycle_Black.png": 1355,
	"./Bikes/Bicycle_Blue.png": 1356,
	"./Bikes/Bicycle_Green.png": 1357,
	"./Bikes/Bicycle_Grey.png": 1358,
	"./Bikes/Bicycle_Red.png": 1359,
	"./Bikes/Bicycle_Yellow.png": 1360,
	"./Bikes/CruiserMotorcycle_Black.png": 1361,
	"./Bikes/CruiserMotorcycle_Blue.png": 1362,
	"./Bikes/CruiserMotorcycle_Green.png": 1363,
	"./Bikes/CruiserMotorcycle_Grey.png": 1364,
	"./Bikes/CruiserMotorcycle_Red.png": 1365,
	"./Bikes/CruiserMotorcycle_Yellow.png": 1366,
	"./Bikes/Motorcycle_Black.png": 1367,
	"./Bikes/Motorcycle_Blue.png": 1368,
	"./Bikes/Motorcycle_Green.png": 1369,
	"./Bikes/Motorcycle_Grey.png": 1370,
	"./Bikes/Motorcycle_Red.png": 1371,
	"./Bikes/Motorcycle_Yellow.png": 1372,
	"./Bikes/QuadBike_Black.png": 1373,
	"./Bikes/QuadBike_Blue.png": 1374,
	"./Bikes/QuadBike_Green.png": 1375,
	"./Bikes/QuadBike_Grey.png": 1376,
	"./Bikes/QuadBike_Red.png": 1377,
	"./Bikes/QuadBike_Yellow.png": 1378,
	"./Bikes/Scooter_Black.png": 1379,
	"./Bikes/Scooter_Blue.png": 1380,
	"./Bikes/Scooter_Green.png": 1381,
	"./Bikes/Scooter_Grey.png": 1382,
	"./Bikes/Scooter_Red.png": 1383,
	"./Bikes/Scooter_Yellow.png": 1384,
	"./Bikes/TouringMotorcycle_Black.png": 1385,
	"./Bikes/TouringMotorcycle_Blue.png": 1386,
	"./Bikes/TouringMotorcycle_Gray.png": 1387,
	"./Bikes/TouringMotorcycle_Green.png": 1388,
	"./Bikes/TouringMotorcycle_Red.png": 1389,
	"./Bikes/TouringMotorcycle_Yellow.png": 1390,
	"./Car/Cabriolet_Black.png": 1391,
	"./Car/Cabriolet_Blue.png": 1392,
	"./Car/Cabriolet_Green.png": 1393,
	"./Car/Cabriolet_Grey.png": 1394,
	"./Car/Cabriolet_Red.png": 1395,
	"./Car/Cabriolet_Yellow.png": 1396,
	"./Car/CamperVan_Black.png": 1397,
	"./Car/CamperVan_Blue.png": 1398,
	"./Car/CamperVan_Green.png": 1399,
	"./Car/CamperVan_Grey.png": 1400,
	"./Car/CamperVan_Red.png": 1401,
	"./Car/CamperVan_Yellow.png": 1402,
	"./Car/Car_Black.png": 1403,
	"./Car/Car_Blue.png": 1404,
	"./Car/Car_Green.png": 1405,
	"./Car/Car_Grey.png": 1406,
	"./Car/Car_Red.png": 1407,
	"./Car/Car_Yellow.png": 1408,
	"./Car/ExecutiveCar_Black.png": 1409,
	"./Car/ExecutiveCar_Blue.png": 1410,
	"./Car/ExecutiveCar_Green.png": 1411,
	"./Car/ExecutiveCar_Grey.png": 1412,
	"./Car/ExecutiveCar_Red.png": 1413,
	"./Car/ExecutiveCar_Yellow.png": 1414,
	"./Car/Hatchback_Black.png": 1415,
	"./Car/Hatchback_Blue.png": 1416,
	"./Car/Hatchback_Green.png": 1417,
	"./Car/Hatchback_Grey.png": 1418,
	"./Car/Hatchback_Red.png": 1419,
	"./Car/Hatchback_Yellow.png": 1420,
	"./Car/HybridCar_Black.png": 1421,
	"./Car/HybridCar_Blue.png": 1422,
	"./Car/HybridCar_Green.png": 1423,
	"./Car/HybridCar_Grey.png": 1424,
	"./Car/HybridCar_Red.png": 1425,
	"./Car/HybridCar_Yellow.png": 1426,
	"./Car/Jeep_Black.png": 1427,
	"./Car/Jeep_Blue.png": 1428,
	"./Car/Jeep_Green.png": 1429,
	"./Car/Jeep_Grey.png": 1430,
	"./Car/Jeep_Red.png": 1431,
	"./Car/Jeep_Yellow.png": 1432,
	"./Car/Limousine_Black.png": 1433,
	"./Car/Limousine_Blue.png": 1434,
	"./Car/Limousine_Green.png": 1435,
	"./Car/Limousine_Grey.png": 1436,
	"./Car/Limousine_Red.png": 1437,
	"./Car/Limousine_Yellow.png": 1438,
	"./Car/LuxuryCar__Black.png": 1439,
	"./Car/LuxuryCar__Blue.png": 1440,
	"./Car/LuxuryCar__Gray.png": 1441,
	"./Car/LuxuryCar__Green.png": 1442,
	"./Car/LuxuryCar__Red.png": 1443,
	"./Car/LuxuryCar__Yellow.png": 1444,
	"./Car/MUV_Black.png": 1445,
	"./Car/MUV_Blue.png": 1446,
	"./Car/MUV_Green.png": 1447,
	"./Car/MUV_Grey.png": 1448,
	"./Car/MUV_Red.png": 1449,
	"./Car/MUV_Yellow.png": 1450,
	"./Car/Minibus_Black.png": 1451,
	"./Car/Minibus_Blue.png": 1452,
	"./Car/Minibus_Green.png": 1453,
	"./Car/Minibus_Grey.png": 1454,
	"./Car/Minibus_Red.png": 1455,
	"./Car/Minibus_Yellow.png": 1456,
	"./Car/MinicarTrailer_Black.png": 1457,
	"./Car/MinicarTrailer_Blue.png": 1458,
	"./Car/MinicarTrailer_Green.png": 1459,
	"./Car/MinicarTrailer_Grey.png": 1460,
	"./Car/MinicarTrailer_Red.png": 1461,
	"./Car/MinicarTrailer_Yellow.png": 1462,
	"./Car/Minicar_Black.png": 1463,
	"./Car/Minicar_Blue.png": 1464,
	"./Car/Minicar_Green.png": 1465,
	"./Car/Minicar_Grey.png": 1466,
	"./Car/Minicar_Red.png": 1467,
	"./Car/Minicar_Yellow.png": 1468,
	"./Car/Minitruck_Black.png": 1469,
	"./Car/Minitruck_Blue.png": 1470,
	"./Car/Minitruck_Green.png": 1471,
	"./Car/Minitruck_Grey.png": 1472,
	"./Car/Minitruck_Red.png": 1473,
	"./Car/Minitruck_Yellow.png": 1474,
	"./Car/PanelVan_Black.png": 1475,
	"./Car/PanelVan_Blue.png": 1476,
	"./Car/PanelVan_Green.png": 1477,
	"./Car/PanelVan_Grey.png": 1478,
	"./Car/PanelVan_Red.png": 1479,
	"./Car/PanelVan_Yellow.png": 1480,
	"./Car/Pickup_Black.png": 1481,
	"./Car/Pickup_Blue.png": 1482,
	"./Car/Pickup_Green.png": 1483,
	"./Car/Pickup_Grey.png": 1484,
	"./Car/Pickup_Red.png": 1485,
	"./Car/Pickup_Yellow.png": 1486,
	"./Car/SUV_Black.png": 1487,
	"./Car/SUV_Blue.png": 1488,
	"./Car/SUV_Green.png": 1489,
	"./Car/SUV_Grey.png": 1490,
	"./Car/SUV_Red.png": 1491,
	"./Car/SUV_Yellow.png": 1492,
	"./Car/ServiceVan_Black.png": 1493,
	"./Car/ServiceVan_Blue.png": 1494,
	"./Car/ServiceVan_Green.png": 1495,
	"./Car/ServiceVan_Grey.png": 1496,
	"./Car/ServiceVan_Red.png": 1497,
	"./Car/ServiceVan_Yellow.png": 1498,
	"./Car/SportsCar_Black.png": 1499,
	"./Car/SportsCar_Blue.png": 1500,
	"./Car/SportsCar_Green.png": 1501,
	"./Car/SportsCar_Grey.png": 1502,
	"./Car/SportsCar_Red.png": 1503,
	"./Car/SportsCar_Yellow.png": 1504,
	"./Car/StationWagon_Black.png": 1505,
	"./Car/StationWagon_Blue.png": 1506,
	"./Car/StationWagon_Green.png": 1507,
	"./Car/StationWagon_Grey.png": 1508,
	"./Car/StationWagon_Red.png": 1509,
	"./Car/StationWagon_Yellow.png": 1510,
	"./Car/Van_Black.png": 1511,
	"./Car/Van_Blue.png": 1512,
	"./Car/Van_Green.png": 1513,
	"./Car/Van_Grey.png": 1514,
	"./Car/Van_Red.png": 1515,
	"./Car/Van_Yellow.png": 1516,
	"./Ecommerce/auction.png": 1517,
	"./Ecommerce/badge-1.png": 1518,
	"./Ecommerce/badge-2.png": 1519,
	"./Ecommerce/badge-3.png": 1520,
	"./Ecommerce/badge-4.png": 1521,
	"./Ecommerce/badge.png": 1522,
	"./Ecommerce/barcode.png": 1523,
	"./Ecommerce/bedside-table.png": 1524,
	"./Ecommerce/billing-machine.png": 1525,
	"./Ecommerce/browser-1.png": 1526,
	"./Ecommerce/browser.png": 1527,
	"./Ecommerce/calculator.png": 1528,
	"./Ecommerce/cash-register.png": 1529,
	"./Ecommerce/click.png": 1530,
	"./Ecommerce/clock.png": 1531,
	"./Ecommerce/closed.png": 1532,
	"./Ecommerce/coin-1.png": 1533,
	"./Ecommerce/coin-stack.png": 1534,
	"./Ecommerce/coin.png": 1535,
	"./Ecommerce/comments.png": 1536,
	"./Ecommerce/compact-disc.png": 1537,
	"./Ecommerce/cosmetics.png": 1538,
	"./Ecommerce/coupon.png": 1539,
	"./Ecommerce/credit-card-1.png": 1540,
	"./Ecommerce/credit-card-2.png": 1541,
	"./Ecommerce/credit-card.png": 1542,
	"./Ecommerce/customer-service.png": 1543,
	"./Ecommerce/delivery-cart.png": 1544,
	"./Ecommerce/delivery-truck-1.png": 1545,
	"./Ecommerce/delivery-truck.png": 1546,
	"./Ecommerce/diamond.png": 1547,
	"./Ecommerce/discount.png": 1548,
	"./Ecommerce/email.png": 1549,
	"./Ecommerce/faq.png": 1550,
	"./Ecommerce/gift-card.png": 1551,
	"./Ecommerce/gift.png": 1552,
	"./Ecommerce/groceries.png": 1553,
	"./Ecommerce/help.png": 1554,
	"./Ecommerce/like.png": 1555,
	"./Ecommerce/money-bag.png": 1556,
	"./Ecommerce/money.png": 1557,
	"./Ecommerce/monitor.png": 1558,
	"./Ecommerce/news.png": 1559,
	"./Ecommerce/notepad.png": 1560,
	"./Ecommerce/online-shop-1.png": 1561,
	"./Ecommerce/online-shop-2.png": 1562,
	"./Ecommerce/online-shop-3.png": 1563,
	"./Ecommerce/online-shop.png": 1564,
	"./Ecommerce/open.png": 1565,
	"./Ecommerce/order.png": 1566,
	"./Ecommerce/package-1.png": 1567,
	"./Ecommerce/package-2.png": 1568,
	"./Ecommerce/package-3.png": 1569,
	"./Ecommerce/package.png": 1570,
	"./Ecommerce/padlock.png": 1571,
	"./Ecommerce/piggy-bank.png": 1572,
	"./Ecommerce/placeholder.png": 1573,
	"./Ecommerce/price-tag.png": 1574,
	"./Ecommerce/promotion.png": 1575,
	"./Ecommerce/purse.png": 1576,
	"./Ecommerce/qr-code.png": 1577,
	"./Ecommerce/receipt.png": 1578,
	"./Ecommerce/refund.png": 1579,
	"./Ecommerce/return.png": 1580,
	"./Ecommerce/review.png": 1581,
	"./Ecommerce/rocket-ship.png": 1582,
	"./Ecommerce/safebox.png": 1583,
	"./Ecommerce/search-1.png": 1584,
	"./Ecommerce/search.png": 1585,
	"./Ecommerce/shield.png": 1586,
	"./Ecommerce/shirt-1.png": 1587,
	"./Ecommerce/shirt.png": 1588,
	"./Ecommerce/shopping-bag-1.png": 1589,
	"./Ecommerce/shopping-bag-2.png": 1590,
	"./Ecommerce/shopping-bag.png": 1591,
	"./Ecommerce/shopping-basket-1.png": 1592,
	"./Ecommerce/shopping-basket-2.png": 1593,
	"./Ecommerce/shopping-basket-3.png": 1594,
	"./Ecommerce/shopping-basket-4.png": 1595,
	"./Ecommerce/shopping-basket.png": 1596,
	"./Ecommerce/shopping-cart-1.png": 1597,
	"./Ecommerce/shopping-cart-2.png": 1598,
	"./Ecommerce/shopping-cart-3.png": 1599,
	"./Ecommerce/shopping-cart-4.png": 1600,
	"./Ecommerce/shopping-cart.png": 1601,
	"./Ecommerce/smartphone-1.png": 1602,
	"./Ecommerce/smartphone.png": 1603,
	"./Ecommerce/star.png": 1604,
	"./Ecommerce/statistics.png": 1605,
	"./Ecommerce/stock-1.png": 1606,
	"./Ecommerce/stock-2.png": 1607,
	"./Ecommerce/stock.png": 1608,
	"./Ecommerce/stopwatch.png": 1609,
	"./Ecommerce/store.png": 1610,
	"./Ecommerce/survey.png": 1611,
	"./Ecommerce/user.png": 1612,
	"./Ecommerce/wallet.png": 1613,
	"./Ecommerce/wishlist-1.png": 1614,
	"./Ecommerce/wishlist.png": 1615,
	"./Ecommerce/worldwide.png": 1616,
	"./Emergencies/001-air-pump.png": 1617,
	"./Emergencies/002-helicopter.png": 1618,
	"./Emergencies/003-defibrillator.png": 1619,
	"./Emergencies/004-toolbox.png": 1620,
	"./Emergencies/005-smartphone.png": 1621,
	"./Emergencies/006-heart.png": 1622,
	"./Emergencies/007-hospital-2.png": 1623,
	"./Emergencies/008-tools.png": 1624,
	"./Emergencies/009-caution.png": 1625,
	"./Emergencies/010-hospital-1.png": 1626,
	"./Emergencies/011-pin.png": 1627,
	"./Emergencies/012-blood-transfusion.png": 1628,
	"./Emergencies/013-firefighter-1.png": 1629,
	"./Emergencies/014-barrier.png": 1630,
	"./Emergencies/015-fire-truck.png": 1631,
	"./Emergencies/016-police-badge.png": 1632,
	"./Emergencies/017-hospital.png": 1633,
	"./Emergencies/018-bucket.png": 1634,
	"./Emergencies/019-smoke-detector.png": 1635,
	"./Emergencies/020-shovel.png": 1636,
	"./Emergencies/021-walkie-talkie.png": 1637,
	"./Emergencies/022-firefighter.png": 1638,
	"./Emergencies/023-stretcher.png": 1639,
	"./Emergencies/024-lifebuoy.png": 1640,
	"./Emergencies/025-fire-extinguisher.png": 1641,
	"./Emergencies/026-warning.png": 1642,
	"./Emergencies/027-hydrant.png": 1643,
	"./Emergencies/028-matches.png": 1644,
	"./Emergencies/029-phone-call.png": 1645,
	"./Emergencies/030-life-jacket.png": 1646,
	"./Emergencies/031-band-aid.png": 1647,
	"./Emergencies/032-lighter.png": 1648,
	"./Emergencies/033-megaphone.png": 1649,
	"./Emergencies/034-sos.png": 1650,
	"./Emergencies/035-whistle.png": 1651,
	"./Emergencies/036-flashlight.png": 1652,
	"./Emergencies/037-sprinkler.png": 1653,
	"./Emergencies/038-fire-alarm-1.png": 1654,
	"./Emergencies/039-gas-mask.png": 1655,
	"./Emergencies/040-ambulance.png": 1656,
	"./Emergencies/041-emergency-call.png": 1657,
	"./Emergencies/042-first-aid-kit.png": 1658,
	"./Emergencies/043-fire.png": 1659,
	"./Emergencies/044-hose.png": 1660,
	"./Emergencies/045-exit.png": 1661,
	"./Emergencies/046-axe.png": 1662,
	"./Emergencies/047-cone.png": 1663,
	"./Emergencies/048-ladder.png": 1664,
	"./Emergencies/049-siren.png": 1665,
	"./Emergencies/050-fire-alarm.png": 1666,
	"./Family/001-couple-3.png": 1667,
	"./Family/002-house.png": 1668,
	"./Family/003-stroller.png": 1669,
	"./Family/004-son.png": 1670,
	"./Family/005-suitcase.png": 1671,
	"./Family/006-family-2.png": 1672,
	"./Family/007-pet-house.png": 1673,
	"./Family/008-cups.png": 1674,
	"./Family/009-photo-album.png": 1675,
	"./Family/010-fireplace.png": 1676,
	"./Family/011-pin.png": 1677,
	"./Family/012-insurance.png": 1678,
	"./Family/013-swing.png": 1679,
	"./Family/014-sofa.png": 1680,
	"./Family/015-couple-2.png": 1681,
	"./Family/016-home-1.png": 1682,
	"./Family/017-daughter.png": 1683,
	"./Family/018-gift-1.png": 1684,
	"./Family/019-shopping-basket.png": 1685,
	"./Family/020-television.png": 1686,
	"./Family/021-divorce.png": 1687,
	"./Family/022-picture-1.png": 1688,
	"./Family/023-briefcase.png": 1689,
	"./Family/024-graduate.png": 1690,
	"./Family/025-pacifier.png": 1691,
	"./Family/026-beach-ball.png": 1692,
	"./Family/027-love.png": 1693,
	"./Family/028-couple-1.png": 1694,
	"./Family/029-couple.png": 1695,
	"./Family/030-scooter.png": 1696,
	"./Family/031-gift.png": 1697,
	"./Family/032-picture.png": 1698,
	"./Family/033-wedding-rings.png": 1699,
	"./Family/034-wedding-cake.png": 1700,
	"./Family/035-newlyweds.png": 1701,
	"./Family/036-grave.png": 1702,
	"./Family/037-crib.png": 1703,
	"./Family/038-cat.png": 1704,
	"./Family/039-father.png": 1705,
	"./Family/040-dog.png": 1706,
	"./Family/041-care.png": 1707,
	"./Family/042-family-1.png": 1708,
	"./Family/043-grandparents.png": 1709,
	"./Family/044-family.png": 1710,
	"./Family/045-home.png": 1711,
	"./Family/046-motherhood.png": 1712,
	"./Family/047-grandfather.png": 1713,
	"./Family/048-grandmother.png": 1714,
	"./Family/049-newborn.png": 1715,
	"./Family/050-mother.png": 1716,
	"./GPS/compass-1.png": 1717,
	"./GPS/compass.png": 1718,
	"./GPS/gps.png": 1719,
	"./GPS/location-1.png": 1720,
	"./GPS/location-2.png": 1721,
	"./GPS/location-3.png": 1722,
	"./GPS/location.png": 184,
	"./GPS/location3.png": 1723,
	"./GPS/location_green.svg": 465,
	"./GPS/locations.png": 1724,
	"./GPS/map-1.png": 1725,
	"./GPS/map-2.png": 1726,
	"./GPS/map-3.png": 1727,
	"./GPS/map.png": 1728,
	"./GPS/navigator.png": 1729,
	"./GPS/panel.png": 1730,
	"./GPS/pin.png": 1731,
	"./GPS/placeholder-1.png": 1732,
	"./GPS/placeholder-2.png": 1733,
	"./GPS/placeholder-3.png": 1734,
	"./GPS/placeholder-4.png": 1735,
	"./GPS/placeholder-5.png": 1736,
	"./GPS/placeholder-6.png": 1737,
	"./GPS/placeholder-7.png": 1738,
	"./GPS/placeholder.png": 111,
	"./GPS/push-pin.png": 1739,
	"./GPS/route-1.png": 1740,
	"./GPS/route.png": 1741,
	"./GPS/satellite.png": 1742,
	"./GPS/selectLocation.svg": 204,
	"./GPS/smartphone-1.png": 1743,
	"./GPS/smartphone.png": 1744,
	"./GPS/target.png": 1745,
	"./Home/alarm-clock.png": 1746,
	"./Home/alcoholic-1.png": 1747,
	"./Home/alcoholic.png": 1748,
	"./Home/bake.png": 1749,
	"./Home/bathing.png": 1750,
	"./Home/bedroom-1.png": 1751,
	"./Home/bedroom-2.png": 1752,
	"./Home/bedroom-3.png": 1753,
	"./Home/bedroom-4.png": 1754,
	"./Home/bedroom-5.png": 1755,
	"./Home/bedroom-6.png": 1756,
	"./Home/bedroom.png": 1757,
	"./Home/bookcase.png": 1758,
	"./Home/carpenter.png": 1759,
	"./Home/carpet.png": 1760,
	"./Home/chairs-1.png": 1761,
	"./Home/chairs-2.png": 1762,
	"./Home/chairs.png": 1763,
	"./Home/chinese-food.png": 1764,
	"./Home/coffee-cup-1.png": 1765,
	"./Home/coffee-cup-2.png": 1766,
	"./Home/coffee-shop.png": 1767,
	"./Home/coffees.png": 1768,
	"./Home/comfortable-1.png": 1769,
	"./Home/comfortable.png": 1770,
	"./Home/coolnes.png": 1771,
	"./Home/couch.png": 1772,
	"./Home/door-key.png": 1773,
	"./Home/drinking.png": 1774,
	"./Home/elegant.png": 1775,
	"./Home/firefighting.png": 1776,
	"./Home/fry.png": 1777,
	"./Home/game-console.png": 1778,
	"./Home/garbage-bin.png": 1779,
	"./Home/gardening.png": 1780,
	"./Home/hair-salon.png": 1781,
	"./Home/hangers.png": 1782,
	"./Home/home-repair.png": 1783,
	"./Home/hot-drink.png": 1784,
	"./Home/hygienic-1.png": 1785,
	"./Home/hygienic.png": 1786,
	"./Home/invention.png": 1787,
	"./Home/japanese-food.png": 1788,
	"./Home/kitchen-pack-1.png": 1789,
	"./Home/kitchen-pack-10.png": 1790,
	"./Home/kitchen-pack-11.png": 1791,
	"./Home/kitchen-pack-12.png": 1792,
	"./Home/kitchen-pack-13.png": 1793,
	"./Home/kitchen-pack-14.png": 1794,
	"./Home/kitchen-pack-15.png": 1795,
	"./Home/kitchen-pack-16.png": 1796,
	"./Home/kitchen-pack-2.png": 1797,
	"./Home/kitchen-pack-3.png": 1798,
	"./Home/kitchen-pack-4.png": 1799,
	"./Home/kitchen-pack-5.png": 1800,
	"./Home/kitchen-pack-6.png": 1801,
	"./Home/kitchen-pack-7.png": 1802,
	"./Home/kitchen-pack-8.png": 1803,
	"./Home/kitchen-pack-9.png": 1804,
	"./Home/kitchen-pack.png": 1805,
	"./Home/kitchen-tools.png": 1806,
	"./Home/laptop-computer.png": 1807,
	"./Home/livingroom-1.png": 1808,
	"./Home/livingroom-2.png": 1809,
	"./Home/livingroom.png": 1810,
	"./Home/passkey.png": 1811,
	"./Home/phone-call.png": 1812,
	"./Home/phone-receiver.png": 1813,
	"./Home/plugging-1.png": 1814,
	"./Home/plugging.png": 1815,
	"./Home/protein.png": 1816,
	"./Home/real-estate-1.png": 1817,
	"./Home/real-estate-2.png": 1818,
	"./Home/real-estate-3.png": 1819,
	"./Home/real-estate.png": 1820,
	"./Home/reflecting.png": 1821,
	"./Home/refreshment.png": 1822,
	"./Home/restauran.png": 1823,
	"./Home/restroom.png": 1824,
	"./Home/seat.png": 1825,
	"./Home/seatting.png": 1826,
	"./Home/showers.png": 1827,
	"./Home/sinks.png": 1828,
	"./Home/sleepy.png": 1829,
	"./Home/studying-1.png": 1830,
	"./Home/studying-2.png": 1831,
	"./Home/studying.png": 1832,
	"./Home/supper.png": 1833,
	"./Home/technological.png": 1834,
	"./Home/televisions-1.png": 1835,
	"./Home/televisions.png": 1836,
	"./Home/ventilator.png": 1837,
	"./Home/wooden-chair.png": 1838,
	"./Home/yard.png": 1839,
	"./Hospital/ambulance.png": 1840,
	"./Hospital/band-aid.png": 1841,
	"./Hospital/bandage.png": 1842,
	"./Hospital/blood-donation.png": 1843,
	"./Hospital/blood-sample.png": 1844,
	"./Hospital/blood-transfusion.png": 1845,
	"./Hospital/broken-bone.png": 1846,
	"./Hospital/cardiogram.png": 1847,
	"./Hospital/clinic-history.png": 1848,
	"./Hospital/coffee-cup.png": 1849,
	"./Hospital/crutches.png": 1850,
	"./Hospital/dna.png": 1851,
	"./Hospital/doctor.png": 1852,
	"./Hospital/dropper.png": 1853,
	"./Hospital/electrocardiogram.png": 1854,
	"./Hospital/eye-drops.png": 1855,
	"./Hospital/eye.png": 1856,
	"./Hospital/first-aid-kit.png": 1857,
	"./Hospital/flask.png": 1858,
	"./Hospital/hospital-1.png": 1859,
	"./Hospital/hospital-2.png": 1860,
	"./Hospital/hospital-bed.png": 1861,
	"./Hospital/hospital.png": 1862,
	"./Hospital/id-card.png": 1863,
	"./Hospital/laptop.png": 1864,
	"./Hospital/mask.png": 1865,
	"./Hospital/medicine-1.png": 1866,
	"./Hospital/medicine-2.png": 1867,
	"./Hospital/medicine-3.png": 1868,
	"./Hospital/medicine-4.png": 1869,
	"./Hospital/medicine.png": 1870,
	"./Hospital/microscope.png": 1871,
	"./Hospital/nurse.png": 1872,
	"./Hospital/optometry.png": 1873,
	"./Hospital/pill.png": 1874,
	"./Hospital/pills-1.png": 1875,
	"./Hospital/pills.png": 1876,
	"./Hospital/placeholder.png": 1877,
	"./Hospital/prescription.png": 1878,
	"./Hospital/serum.png": 1879,
	"./Hospital/shirt.png": 1880,
	"./Hospital/smartphone.png": 1881,
	"./Hospital/stethoscope.png": 1882,
	"./Hospital/tag.png": 1883,
	"./Hospital/test-tube.png": 1884,
	"./Hospital/thermometer.png": 1885,
	"./Hospital/tooth.png": 1886,
	"./Hospital/vaccine.png": 1887,
	"./Hospital/virus.png": 1888,
	"./Hospital/weight.png": 1889,
	"./Lights/amber_light.png": 1890,
	"./Lights/green_light.png": 1891,
	"./Lights/grey_light.png": 1892,
	"./Lights/red_light.png": 1893,
	"./Lights/traffic_light_green.png": 1894,
	"./Lights/traffic_light_none.png": 1895,
	"./Lights/traffic_light_red.png": 1896,
	"./Lights/trafficlight.png": 1897,
	"./Lights/trafficlightcolour.png": 1898,
	"./Logistics/001-distribution-5.png": 1899,
	"./Logistics/002-aerial.png": 1900,
	"./Logistics/003-frontal-view.png": 1901,
	"./Logistics/004-distribution-4.png": 1902,
	"./Logistics/005-clipboards.png": 1903,
	"./Logistics/006-oceanic.png": 1904,
	"./Logistics/007-placeholders-1.png": 1905,
	"./Logistics/008-international.png": 1906,
	"./Logistics/009-packages-2.png": 1907,
	"./Logistics/010-tools-and-utensils-3.png": 1908,
	"./Logistics/011-weekly-calendar.png": 1909,
	"./Logistics/012-placeholders.png": 1910,
	"./Logistics/013-distribution-3.png": 1911,
	"./Logistics/014-shopping-carts-1.png": 1912,
	"./Logistics/015-maps-and-flags-1.png": 1913,
	"./Logistics/016-organizing.png": 1914,
	"./Logistics/017-maps-and-flags.png": 1915,
	"./Logistics/018-tools-and-utensils-2.png": 1916,
	"./Logistics/019-call-center-1.png": 1917,
	"./Logistics/020-protected.png": 1918,
	"./Logistics/021-cubes.png": 1919,
	"./Logistics/022-distribution-2.png": 1920,
	"./Logistics/023-call-center.png": 1921,
	"./Logistics/024-bussiness.png": 1922,
	"./Logistics/025-charter.png": 1923,
	"./Logistics/026-trolley-cart.png": 1924,
	"./Logistics/027-distribution-1.png": 1925,
	"./Logistics/028-tools-and-utensils-1.png": 1926,
	"./Logistics/029-airplanes.png": 1927,
	"./Logistics/030-verified.png": 1928,
	"./Logistics/031-shopping-carts.png": 1929,
	"./Logistics/032-transportation.png": 1930,
	"./Logistics/033-packages-1.png": 1931,
	"./Logistics/034-changing.png": 1932,
	"./Logistics/035-packages.png": 1933,
	"./Logistics/036-symbolic.png": 1934,
	"./Logistics/037-packing.png": 1935,
	"./Logistics/038-trucks.png": 1936,
	"./Logistics/039-tools-and-utensils.png": 1937,
	"./Logistics/040-circular-arrows.png": 1938,
	"./Logistics/041-debit-card.png": 1939,
	"./Logistics/042-24-hours.png": 1940,
	"./Logistics/043-distribution.png": 1941,
	"./Logistics/044-cargo-ship.png": 1942,
	"./Machinery/BackhoeLoader_Black.png": 1943,
	"./Machinery/BackhoeLoader_Blue.png": 1944,
	"./Machinery/BackhoeLoader_Green.png": 1945,
	"./Machinery/BackhoeLoader_Grey.png": 1946,
	"./Machinery/BackhoeLoader_Red.png": 1947,
	"./Machinery/BackhoeLoader_Yellow.png": 1948,
	"./Machinery/Bulldozer_Black.png": 1949,
	"./Machinery/Bulldozer_Blue.png": 1950,
	"./Machinery/Bulldozer_Green.png": 1951,
	"./Machinery/Bulldozer_Grey.png": 1952,
	"./Machinery/Bulldozer_Red.png": 1953,
	"./Machinery/Bulldozer_Yellow.png": 1954,
	"./Machinery/CompactExcavator_Black.png": 1955,
	"./Machinery/CompactExcavator_Blue.png": 1956,
	"./Machinery/CompactExcavator_Green.png": 1957,
	"./Machinery/CompactExcavator_Grey.png": 1958,
	"./Machinery/CompactExcavator_Red.png": 1959,
	"./Machinery/CompactExcavator_Yellow.png": 1960,
	"./Machinery/Excavator_Black.png": 1961,
	"./Machinery/Excavator_Blue.png": 1962,
	"./Machinery/Excavator_Green.png": 1963,
	"./Machinery/Excavator_Grey.png": 1964,
	"./Machinery/Excavator_Red.png": 1965,
	"./Machinery/Excavator_Yellow.png": 1966,
	"./Machinery/FarmTractor_Black.png": 1967,
	"./Machinery/FarmTractor_Blue.png": 1968,
	"./Machinery/FarmTractor_Green.png": 1969,
	"./Machinery/FarmTractor_Grey.png": 1970,
	"./Machinery/FarmTractor_Red.png": 1971,
	"./Machinery/FarmTractor_Yellow.png": 1972,
	"./Machinery/ForkliftTruck_Loaded_Black.png": 1973,
	"./Machinery/ForkliftTruck_Loaded_Blue.png": 1974,
	"./Machinery/ForkliftTruck_Loaded_Green.png": 1975,
	"./Machinery/ForkliftTruck_Loaded_Grey.png": 1976,
	"./Machinery/ForkliftTruck_Loaded_Red.png": 1977,
	"./Machinery/ForkliftTruck_Loaded_Yellow.png": 1978,
	"./Machinery/ForkliftTruck__Black.png": 1979,
	"./Machinery/ForkliftTruck__Blue.png": 1980,
	"./Machinery/ForkliftTruck__Green.png": 1981,
	"./Machinery/ForkliftTruck__Grey.png": 1982,
	"./Machinery/ForkliftTruck__Red.png": 1983,
	"./Machinery/ForkliftTruck__Yellow.png": 1984,
	"./Machinery/LandfillCompactor_Black.png": 1985,
	"./Machinery/LandfillCompactor_Blue.png": 1986,
	"./Machinery/LandfillCompactor_Green.png": 1987,
	"./Machinery/LandfillCompactor_Grey.png": 1988,
	"./Machinery/LandfillCompactor_Red.png": 1989,
	"./Machinery/LandfillCompactor_Yellow.png": 1990,
	"./Machinery/Loader_Black.png": 1991,
	"./Machinery/Loader_Blue.png": 1992,
	"./Machinery/Loader_Green.png": 1993,
	"./Machinery/Loader_Grey.png": 1994,
	"./Machinery/Loader_Red.png": 1995,
	"./Machinery/Loader_Yellow.png": 1996,
	"./Machinery/MaterialHandler_Black.png": 1997,
	"./Machinery/MaterialHandler_Blue.png": 1998,
	"./Machinery/MaterialHandler_Green.png": 1999,
	"./Machinery/MaterialHandler_Grey.png": 2000,
	"./Machinery/MaterialHandler_Red.png": 2001,
	"./Machinery/MaterialHandler_Yellow.png": 2002,
	"./Machinery/RoadRoller_Black.png": 2003,
	"./Machinery/RoadRoller_Blue.png": 2004,
	"./Machinery/RoadRoller_Green.png": 2005,
	"./Machinery/RoadRoller_Grey.png": 2006,
	"./Machinery/RoadRoller_Red.png": 2007,
	"./Machinery/RoadRoller_Yellow.png": 2008,
	"./Machinery/RoadSweeper_Black.png": 2009,
	"./Machinery/RoadSweeper_Blue.png": 2010,
	"./Machinery/RoadSweeper_Green.png": 2011,
	"./Machinery/RoadSweeper_Grey.png": 2012,
	"./Machinery/RoadSweeper_Red.png": 2013,
	"./Machinery/RoadSweeper_Yellow.png": 2014,
	"./Machinery/RollerCompactor_Black.png": 2015,
	"./Machinery/RollerCompactor_Blue.png": 2016,
	"./Machinery/RollerCompactor_Green.png": 2017,
	"./Machinery/RollerCompactor_Grey.png": 2018,
	"./Machinery/RollerCompactor_Red.png": 2019,
	"./Machinery/RollerCompactor_Yellow.png": 2020,
	"./Machinery/SkidSteerLoader_Black.png": 2021,
	"./Machinery/SkidSteerLoader_Blue.png": 2022,
	"./Machinery/SkidSteerLoader_Green.png": 2023,
	"./Machinery/SkidSteerLoader_Grey.png": 2024,
	"./Machinery/SkidSteerLoader_Red.png": 2025,
	"./Machinery/SkidSteerLoader_Yellow.png": 2026,
	"./Machinery/SkipLoader_Black.png": 2027,
	"./Machinery/SkipLoader_Blue.png": 2028,
	"./Machinery/SkipLoader_Green.png": 2029,
	"./Machinery/SkipLoader_Grey.png": 2030,
	"./Machinery/SkipLoader_Red.png": 2031,
	"./Machinery/SkipLoader_Yellow.png": 2032,
	"./Machinery/SoilStabilizer_Black.png": 2033,
	"./Machinery/SoilStabilizer_Blue.png": 2034,
	"./Machinery/SoilStabilizer_Green.png": 2035,
	"./Machinery/SoilStabilizer_Grey.png": 2036,
	"./Machinery/SoilStabilizer_Red.png": 2037,
	"./Machinery/SoilStabilizer_Yellow.png": 2038,
	"./Machinery/SteamRoller_Black.png": 2039,
	"./Machinery/SteamRoller_Blue.png": 2040,
	"./Machinery/SteamRoller_Green.png": 2041,
	"./Machinery/SteamRoller_Grey.png": 2042,
	"./Machinery/SteamRoller_Red.png": 2043,
	"./Machinery/SteamRoller_Yellow.png": 2044,
	"./Machinery/StreetSweeper_Black.png": 2045,
	"./Machinery/StreetSweeper_Blue.png": 2046,
	"./Machinery/StreetSweeper_Green.png": 2047,
	"./Machinery/StreetSweeper_Grey.png": 2048,
	"./Machinery/StreetSweeper_Red.png": 2049,
	"./Machinery/StreetSweeper_Yellow.png": 2050,
	"./Machinery/TelescopicHandler_Black.png": 2051,
	"./Machinery/TelescopicHandler_Blue.png": 2052,
	"./Machinery/TelescopicHandler_Green.png": 2053,
	"./Machinery/TelescopicHandler_Grey.png": 2054,
	"./Machinery/TelescopicHandler_Red.png": 2055,
	"./Machinery/TelescopicHandler_Yellow.png": 2056,
	"./Machinery/TruckMountedCrane_Working_Black.png": 2057,
	"./Machinery/TruckMountedCrane_Working_Blue.png": 2058,
	"./Machinery/TruckMountedCrane_Working_Green.png": 2059,
	"./Machinery/TruckMountedCrane_Working_Grey.png": 2060,
	"./Machinery/TruckMountedCrane_Working_Red.png": 2061,
	"./Machinery/TruckMountedCrane_Working_Yellow.png": 2062,
	"./Machinery/TruckMountedCrane__Black.png": 2063,
	"./Machinery/TruckMountedCrane__Blue.png": 2064,
	"./Machinery/TruckMountedCrane__Green.png": 2065,
	"./Machinery/TruckMountedCrane__Grey.png": 2066,
	"./Machinery/TruckMountedCrane__Red.png": 2067,
	"./Machinery/TruckMountedCrane__Yellow.png": 2068,
	"./Machinery/WheeledExcavator_Black.png": 2069,
	"./Machinery/WheeledExcavator_Blue.png": 2070,
	"./Machinery/WheeledExcavator_Green.png": 2071,
	"./Machinery/WheeledExcavator_Grey.png": 2072,
	"./Machinery/WheeledExcavator_Red.png": 2073,
	"./Machinery/WheeledExcavator_Yellow.png": 2074,
	"./Machinery/WreckingBall_Black.png": 2075,
	"./Machinery/WreckingBall_Blue.png": 2076,
	"./Machinery/WreckingBall_Green.png": 2077,
	"./Machinery/WreckingBall_Grey.png": 2078,
	"./Machinery/WreckingBall_Red.png": 2079,
	"./Machinery/WreckingBall_Yellow.png": 2080,
	"./Marine/001-pirate-3.png": 2081,
	"./Marine/001-whale.png": 2082,
	"./Marine/002-hook.png": 2083,
	"./Marine/002-lifesaver.png": 2084,
	"./Marine/003-round-shot.png": 2085,
	"./Marine/003-sailor-cap-2.png": 2086,
	"./Marine/004-anchor-2.png": 2087,
	"./Marine/004-starfish.png": 2088,
	"./Marine/005-anchor-1.png": 2089,
	"./Marine/005-cannon.png": 2090,
	"./Marine/006-dolphin.png": 2091,
	"./Marine/006-parrot.png": 2092,
	"./Marine/007-island.png": 2093,
	"./Marine/007-knot-1.png": 2094,
	"./Marine/008-pirate-2.png": 2095,
	"./Marine/008-sailor-cap-1.png": 2096,
	"./Marine/009-flag.png": 2097,
	"./Marine/009-key.png": 2098,
	"./Marine/010-barrel.png": 2099,
	"./Marine/010-seagull-1.png": 2100,
	"./Marine/011-boat.png": 2101,
	"./Marine/011-paddle.png": 2102,
	"./Marine/012-pirate-ship.png": 2103,
	"./Marine/012-porthole.png": 2104,
	"./Marine/013-bollard.png": 2105,
	"./Marine/013-gold-ingots.png": 2106,
	"./Marine/014-lighthouse-1.png": 2107,
	"./Marine/014-placeholder.png": 2108,
	"./Marine/015-buoys.png": 2109,
	"./Marine/015-skull-and-bones.png": 2110,
	"./Marine/016-flippers.png": 2111,
	"./Marine/016-sword.png": 2112,
	"./Marine/017-pirate-1.png": 2113,
	"./Marine/017-shirt.png": 2114,
	"./Marine/018-chains.png": 2115,
	"./Marine/018-pipe.png": 2116,
	"./Marine/019-eyepatch.png": 2117,
	"./Marine/019-pipe-1.png": 2118,
	"./Marine/020-compass-2.png": 2119,
	"./Marine/020-gallows.png": 2120,
	"./Marine/021-coin.png": 2121,
	"./Marine/021-radar-1.png": 2122,
	"./Marine/022-compass-1.png": 2123,
	"./Marine/022-rum.png": 2124,
	"./Marine/023-money-bag.png": 2125,
	"./Marine/023-radar.png": 2126,
	"./Marine/024-diving-helmet.png": 2127,
	"./Marine/024-pirate.png": 2128,
	"./Marine/025-bottle.png": 2129,
	"./Marine/025-treasure-map.png": 2130,
	"./Marine/026-captain.png": 2131,
	"./Marine/026-wooden-leg.png": 2132,
	"./Marine/027-helm.png": 2133,
	"./Marine/027-yatch.png": 2134,
	"./Marine/028-message-in-a-bottle.png": 2135,
	"./Marine/028-oars.png": 2136,
	"./Marine/029-lighthouse.png": 2137,
	"./Marine/029-ship.png": 2138,
	"./Marine/030-binoculars.png": 2139,
	"./Marine/030-torch.png": 2140,
	"./Marine/031-jolly-roger.png": 2141,
	"./Marine/031-propeller.png": 2142,
	"./Marine/032-bell.png": 2143,
	"./Marine/032-hook.png": 2144,
	"./Marine/033-dice.png": 2145,
	"./Marine/033-map.png": 2146,
	"./Marine/034-sailor-cap.png": 2147,
	"./Marine/034-telescope.png": 2148,
	"./Marine/035-knot.png": 2149,
	"./Marine/035-tortoise.png": 2150,
	"./Marine/036-letter.png": 2151,
	"./Marine/036-waves.png": 2152,
	"./Marine/037-anchor.png": 2153,
	"./Marine/037-pipe.png": 2154,
	"./Marine/038-compass.png": 2155,
	"./Marine/038-lifebuoy.png": 2156,
	"./Marine/039-bomb.png": 2157,
	"./Marine/039-rudder-1.png": 2158,
	"./Marine/040-sailboat.png": 2159,
	"./Marine/040-treasure.png": 2160,
	"./Marine/041-starfish.png": 2161,
	"./Marine/042-lighthouse.png": 2162,
	"./Marine/043-spyglass.png": 2163,
	"./Marine/044-fish.png": 2164,
	"./Marine/045-compass.png": 2165,
	"./Marine/046-anchor.png": 2166,
	"./Marine/047-seagull.png": 2167,
	"./Marine/048-rudder.png": 2168,
	"./Marine/049-snorkel.png": 2169,
	"./Marine/050-life-jacket.png": 2170,
	"./Military/001-knife.png": 2171,
	"./Military/002-bomb-1.png": 2172,
	"./Military/003-radar.png": 2173,
	"./Military/004-medal-1.png": 2174,
	"./Military/005-launcher-1.png": 2175,
	"./Military/006-helmet.png": 2176,
	"./Military/007-chamber.png": 2177,
	"./Military/008-helicopter.png": 2178,
	"./Military/009-soldier.png": 2179,
	"./Military/010-lieutenant.png": 2180,
	"./Military/011-shotgun.png": 2181,
	"./Military/012-backpack.png": 2182,
	"./Military/013-bomb-detonation-1.png": 2183,
	"./Military/014-bomb-detonation.png": 2184,
	"./Military/015-fighter-plane.png": 2185,
	"./Military/016-dynamite.png": 2186,
	"./Military/017-first-aid-kit-1.png": 2187,
	"./Military/018-boat.png": 2188,
	"./Military/019-submarine.png": 2189,
	"./Military/020-compass.png": 2190,
	"./Military/021-insignia.png": 2191,
	"./Military/022-first-aid-kit.png": 2192,
	"./Military/023-placeholder.png": 2193,
	"./Military/024-jet.png": 2194,
	"./Military/025-flag.png": 2195,
	"./Military/026-boots.png": 2196,
	"./Military/027-gas-mask.png": 2197,
	"./Military/028-bullet-1.png": 2198,
	"./Military/029-launcher.png": 2199,
	"./Military/030-satellite-dish.png": 2200,
	"./Military/031-parachute.png": 2201,
	"./Military/032-gun.png": 2202,
	"./Military/033-bulletproof.png": 2203,
	"./Military/034-swiss-army-knife.png": 2204,
	"./Military/035-bullet.png": 2205,
	"./Military/036-binoculars.png": 2206,
	"./Military/037-target.png": 2207,
	"./Military/038-walkie-talkie.png": 2208,
	"./Military/039-rank.png": 2209,
	"./Military/040-barbed.png": 2210,
	"./Military/041-bomb.png": 2211,
	"./Military/042-radiation.png": 2212,
	"./Military/043-chevron.png": 2213,
	"./Military/044-map.png": 2214,
	"./Military/045-medal.png": 2215,
	"./Military/046-tank.png": 2216,
	"./Military/047-tent.png": 2217,
	"./Military/048-dog-tags-military.png": 2218,
	"./Military/049-grenade.png": 2219,
	"./Military/050-badge.png": 2220,
	"./Multimedia/3d-glasses.png": 2221,
	"./Multimedia/antenna.png": 2222,
	"./Multimedia/camera-1.png": 2223,
	"./Multimedia/camera-2.png": 2224,
	"./Multimedia/camera-3.png": 2225,
	"./Multimedia/camera.png": 2226,
	"./Multimedia/cd.png": 2227,
	"./Multimedia/chat.png": 2228,
	"./Multimedia/clapperboard.png": 2229,
	"./Multimedia/cloud.png": 2230,
	"./Multimedia/compact-disc.png": 2231,
	"./Multimedia/dvd.png": 2232,
	"./Multimedia/equalizer.png": 2233,
	"./Multimedia/film.png": 2234,
	"./Multimedia/floppy-disk.png": 2235,
	"./Multimedia/game.png": 2236,
	"./Multimedia/ipod-shuffle.png": 2237,
	"./Multimedia/ipod.png": 2238,
	"./Multimedia/keyboard.png": 2239,
	"./Multimedia/loudspeaker-1.png": 2240,
	"./Multimedia/loudspeaker.png": 2241,
	"./Multimedia/memory-card.png": 2242,
	"./Multimedia/microphone-1.png": 2243,
	"./Multimedia/microphone.png": 2244,
	"./Multimedia/mobile-phone.png": 2245,
	"./Multimedia/modem.png": 2246,
	"./Multimedia/negative-film.png": 2247,
	"./Multimedia/negative.png": 2248,
	"./Multimedia/next-track.png": 2249,
	"./Multimedia/pause.png": 2250,
	"./Multimedia/photos.png": 2251,
	"./Multimedia/play.png": 2252,
	"./Multimedia/previous-track.png": 2253,
	"./Multimedia/radio.png": 2254,
	"./Multimedia/rec.png": 2255,
	"./Multimedia/speaker.png": 2256,
	"./Multimedia/stop.png": 2257,
	"./Multimedia/tablet.png": 2258,
	"./Multimedia/tv-1.png": 2259,
	"./Multimedia/tv.png": 2260,
	"./Multimedia/web-cam.png": 2261,
	"./Office/adhesive-tape.png": 2262,
	"./Office/bookshelf.png": 2263,
	"./Office/box.png": 2264,
	"./Office/briefcase.png": 2265,
	"./Office/business-card.png": 2266,
	"./Office/cabinet.png": 2267,
	"./Office/calculator.png": 2268,
	"./Office/calendar.png": 2269,
	"./Office/clipboard.png": 2270,
	"./Office/clock.png": 2271,
	"./Office/coffee-cup.png": 2272,
	"./Office/computer.png": 2273,
	"./Office/copy-machine.png": 2274,
	"./Office/documents.png": 2275,
	"./Office/fax.png": 2276,
	"./Office/folder-1.png": 2277,
	"./Office/folder-2.png": 2278,
	"./Office/folder.png": 2279,
	"./Office/garbage.png": 2280,
	"./Office/headphones.png": 2281,
	"./Office/highlighter.png": 2282,
	"./Office/hole-puncher.png": 2283,
	"./Office/id-card.png": 2284,
	"./Office/lamp.png": 2285,
	"./Office/laptop.png": 2286,
	"./Office/letters.png": 2287,
	"./Office/mail.png": 2288,
	"./Office/mouse.png": 2289,
	"./Office/mug.png": 2290,
	"./Office/note.png": 2291,
	"./Office/notebook-1.png": 2292,
	"./Office/notebook.png": 2293,
	"./Office/office-chair.png": 2294,
	"./Office/paper-shredder.png": 2295,
	"./Office/pen.png": 2296,
	"./Office/pencil-case.png": 2297,
	"./Office/pendrive.png": 2298,
	"./Office/plant.png": 2299,
	"./Office/presentation.png": 2300,
	"./Office/printer.png": 2301,
	"./Office/projector.png": 2302,
	"./Office/push-pin.png": 2303,
	"./Office/router.png": 2304,
	"./Office/rubber-stamp.png": 2305,
	"./Office/safebox.png": 2306,
	"./Office/stapler.png": 2307,
	"./Office/table.png": 2308,
	"./Office/telephone.png": 2309,
	"./Office/uniform.png": 2310,
	"./Office/webcam.png": 2311,
	"./Professions/astronaut.png": 2312,
	"./Professions/athlete.png": 2313,
	"./Professions/builder.png": 2314,
	"./Professions/carpenter.png": 2315,
	"./Professions/cashier.png": 2316,
	"./Professions/chef.png": 2317,
	"./Professions/chemist.png": 2318,
	"./Professions/clown.png": 2319,
	"./Professions/concierge.png": 2320,
	"./Professions/courier.png": 2321,
	"./Professions/detective.png": 2322,
	"./Professions/diver.png": 2323,
	"./Professions/dj.png": 2324,
	"./Professions/doctor.png": 2325,
	"./Professions/dyer.png": 2326,
	"./Professions/electrician.png": 2327,
	"./Professions/farmer.png": 2328,
	"./Professions/firefighter.png": 2329,
	"./Professions/fisherman.png": 2330,
	"./Professions/gardener.png": 2331,
	"./Professions/hairdresser.png": 2332,
	"./Professions/lumberjack.png": 2333,
	"./Professions/magician.png": 2334,
	"./Professions/maid.png": 2335,
	"./Professions/manager.png": 2336,
	"./Professions/mechanic.png": 2337,
	"./Professions/miner.png": 2338,
	"./Professions/nurse.png": 2339,
	"./Professions/painter.png": 2340,
	"./Professions/pensioner.png": 2341,
	"./Professions/personplaceholder.png": 371,
	"./Professions/photographer.png": 2342,
	"./Professions/pilot.png": 2343,
	"./Professions/plumber.png": 2344,
	"./Professions/policeman.png": 2345,
	"./Professions/politician.png": 2346,
	"./Professions/postman.png": 2347,
	"./Professions/priest.png": 2348,
	"./Professions/professor.png": 2349,
	"./Professions/programmer.png": 2350,
	"./Professions/sailor.png": 2351,
	"./Professions/secretary.png": 2352,
	"./Professions/showman.png": 2353,
	"./Professions/singer.png": 2354,
	"./Professions/soldier.png": 2355,
	"./Professions/stewardess.png": 2356,
	"./Professions/support.png": 2357,
	"./Professions/taxi-driver.png": 2358,
	"./Professions/teacher.png": 2359,
	"./Professions/waiter.png": 2360,
	"./Professions/writer.png": 2361,
	"./PublicTransport/Coach_Black.png": 2362,
	"./PublicTransport/Coach_Blue.png": 2363,
	"./PublicTransport/Coach_Green.png": 2364,
	"./PublicTransport/Coach_Grey.png": 2365,
	"./PublicTransport/Coach_Red.png": 2366,
	"./PublicTransport/Coach_Yellow.png": 2367,
	"./PublicTransport/CommuterBus_Black.png": 2368,
	"./PublicTransport/CommuterBus_Blue.png": 2369,
	"./PublicTransport/CommuterBus_Green.png": 2370,
	"./PublicTransport/CommuterBus_Grey.png": 2371,
	"./PublicTransport/CommuterBus_Red.png": 2372,
	"./PublicTransport/CommuterBus_Yellow.png": 2373,
	"./PublicTransport/Taxi_Black.png": 2374,
	"./PublicTransport/Taxi_Blue.png": 2375,
	"./PublicTransport/Taxi_Green.png": 2376,
	"./PublicTransport/Taxi_Grey.png": 2377,
	"./PublicTransport/Taxi_Red.png": 2378,
	"./PublicTransport/Taxi_Yellow.png": 2379,
	"./PublicTransport/TransitBus_Black.png": 2380,
	"./PublicTransport/TransitBus_Blue.png": 2381,
	"./PublicTransport/TransitBus_Green.png": 2382,
	"./PublicTransport/TransitBus_Grey.png": 2383,
	"./PublicTransport/TransitBus_Red.png": 2384,
	"./PublicTransport/TransitBus_Yellow.png": 2385,
	"./Safety/001-fire.png": 2386,
	"./Safety/002-umbrella.png": 2387,
	"./Safety/003-shield-1.png": 2388,
	"./Safety/004-lifebuoy.png": 2389,
	"./Safety/005-cone.png": 2390,
	"./Safety/006-eye.png": 2391,
	"./Safety/007-helmet.png": 2392,
	"./Safety/008-safety-belt.png": 2393,
	"./Safety/009-first-aid-kit.png": 2394,
	"./Safety/010-barbed-wire.png": 2395,
	"./Safety/011-shield.png": 2396,
	"./Safety/012-cctv-1.png": 2397,
	"./Safety/013-cctv.png": 2398,
	"./Safety/014-fire-alarm-1.png": 2399,
	"./Safety/015-hose.png": 2400,
	"./Safety/016-hydrant.png": 2401,
	"./Safety/017-flasher.png": 2402,
	"./Safety/018-kitchen-hood.png": 2403,
	"./Safety/019-air-compressor.png": 2404,
	"./Safety/020-gas-mask.png": 2405,
	"./Safety/021-carbon-monoxide.png": 2406,
	"./Safety/022-extinguisher.png": 2407,
	"./Safety/023-sprinkler.png": 2408,
	"./Safety/024-pull.png": 2409,
	"./Safety/025-fire-alarm.png": 2410,
	"./Safety/026-smoke-detector.png": 2411,
	"./Safety/027-safety-code.png": 2412,
	"./Safety/028-signal.png": 2413,
	"./Safety/029-strongbox.png": 2414,
	"./Safety/030-password.png": 2415,
	"./Safety/031-key.png": 2416,
	"./Safety/032-keyhole.png": 2417,
	"./Safety/033-exit-1.png": 2418,
	"./Safety/034-door.png": 2419,
	"./Safety/035-padlock-1.png": 2420,
	"./Safety/036-padlock.png": 2421,
	"./Safety/037-house.png": 2422,
	"./Safety/038-exit.png": 2423,
	"./Safety/039-bell.png": 2424,
	"./Safety/040-stop.png": 2425,
	"./Safety/041-radiation.png": 2426,
	"./Safety/042-forbidden.png": 2427,
	"./Safety/043-not-touch.png": 2428,
	"./Safety/044-no-smoking.png": 2429,
	"./Safety/045-no-fire.png": 2430,
	"./Safety/046-high-voltage.png": 2431,
	"./Safety/047-fire-sign.png": 2432,
	"./Safety/048-warning.png": 2433,
	"./Safety/049-bomb.png": 2434,
	"./Safety/050-antenna.png": 2435,
	"./Shipping/aeroplane.png": 2436,
	"./Shipping/barcode.png": 2437,
	"./Shipping/box-1.png": 2438,
	"./Shipping/box.png": 2439,
	"./Shipping/boxes.png": 2440,
	"./Shipping/calendar.png": 2441,
	"./Shipping/clipboard.png": 2442,
	"./Shipping/container.png": 2443,
	"./Shipping/delivery-1.png": 2444,
	"./Shipping/delivery-2.png": 2445,
	"./Shipping/delivery-3.png": 2446,
	"./Shipping/delivery-truck.png": 2447,
	"./Shipping/delivery.png": 2448,
	"./Shipping/envelope.png": 2449,
	"./Shipping/find.png": 2450,
	"./Shipping/fragile.png": 2451,
	"./Shipping/gift.png": 2452,
	"./Shipping/laptop.png": 2453,
	"./Shipping/package-1.png": 2454,
	"./Shipping/package-2.png": 2455,
	"./Shipping/package-3.png": 2456,
	"./Shipping/package-4.png": 2457,
	"./Shipping/package-5.png": 2458,
	"./Shipping/package-6.png": 2459,
	"./Shipping/package-7.png": 2460,
	"./Shipping/package.png": 2461,
	"./Shipping/route.png": 2462,
	"./Shipping/safety.png": 2463,
	"./Shipping/ship.png": 2464,
	"./Shipping/shipping.png": 2465,
	"./Shipping/smartphone.png": 2466,
	"./Shipping/stroller.png": 2467,
	"./Shipping/support.png": 2468,
	"./Shipping/train.png": 2469,
	"./Shipping/up.png": 2470,
	"./Shipping/warehouse-1.png": 2471,
	"./Shipping/warehouse-2.png": 2472,
	"./Shipping/warehouse.png": 2473,
	"./Shipping/weight.png": 2474,
	"./Shipping/worldwide.png": 2475,
	"./Tools/atomic.png": 2476,
	"./Tools/awl.png": 2477,
	"./Tools/axe.png": 2478,
	"./Tools/barrels.png": 2479,
	"./Tools/battery-1.png": 2480,
	"./Tools/battery.png": 2481,
	"./Tools/box.png": 2482,
	"./Tools/charging.png": 2483,
	"./Tools/chisel.png": 2484,
	"./Tools/clamp.png": 2485,
	"./Tools/coal.png": 2486,
	"./Tools/compass.png": 2487,
	"./Tools/cutter.png": 2488,
	"./Tools/driller.png": 2489,
	"./Tools/ecology.png": 2490,
	"./Tools/electric-car.png": 2491,
	"./Tools/electric-tower.png": 2492,
	"./Tools/eolic-energy.png": 2493,
	"./Tools/factory.png": 2494,
	"./Tools/faucet.png": 2495,
	"./Tools/file.png": 2496,
	"./Tools/gas-station.png": 2497,
	"./Tools/gas.png": 2498,
	"./Tools/glue.png": 2499,
	"./Tools/hammer-1.png": 2500,
	"./Tools/hammer-2.png": 2501,
	"./Tools/hammer.png": 2502,
	"./Tools/house.png": 2503,
	"./Tools/hydro-power.png": 2504,
	"./Tools/jigsaw.png": 2505,
	"./Tools/ladder.png": 2506,
	"./Tools/level.png": 2507,
	"./Tools/light-bulb.png": 2508,
	"./Tools/low-battery.png": 2509,
	"./Tools/marker.png": 2510,
	"./Tools/mat.png": 2511,
	"./Tools/measuring-tape.png": 2512,
	"./Tools/nail.png": 2513,
	"./Tools/needle.png": 2514,
	"./Tools/nut.png": 2515,
	"./Tools/oil-platform.png": 2516,
	"./Tools/paint-brush-1.png": 2517,
	"./Tools/paint-brush-2.png": 2518,
	"./Tools/paint-brush.png": 2519,
	"./Tools/paint-bucket.png": 2520,
	"./Tools/paint-palette.png": 2521,
	"./Tools/paint-roller.png": 2522,
	"./Tools/pantone.png": 2523,
	"./Tools/pencil.png": 2524,
	"./Tools/pliers-1.png": 2525,
	"./Tools/pliers-2.png": 2526,
	"./Tools/pliers.png": 2527,
	"./Tools/plug.png": 2528,
	"./Tools/power-button.png": 2529,
	"./Tools/power-plant.png": 2530,
	"./Tools/rain.png": 2531,
	"./Tools/recycle.png": 2532,
	"./Tools/renewable-energy-1.png": 2533,
	"./Tools/renewable-energy.png": 2534,
	"./Tools/ruler-1.png": 2535,
	"./Tools/ruler.png": 2536,
	"./Tools/save-energy.png": 2537,
	"./Tools/saw-1.png": 2538,
	"./Tools/saw.png": 2539,
	"./Tools/scissors.png": 2540,
	"./Tools/screw.png": 2541,
	"./Tools/screwdriver.png": 2542,
	"./Tools/set-square.png": 2543,
	"./Tools/shovel-1.png": 2544,
	"./Tools/shovel.png": 2545,
	"./Tools/socket.png": 2546,
	"./Tools/solar-energy.png": 2547,
	"./Tools/spatula.png": 2548,
	"./Tools/tape.png": 2549,
	"./Tools/toolbox.png": 2550,
	"./Tools/usb-cable.png": 2551,
	"./Tools/workplace.png": 2552,
	"./Tools/wrench-1.png": 2553,
	"./Tools/wrench-2.png": 2554,
	"./Tools/wrench.png": 2555,
	"./Traffic/001-highway-1.png": 2556,
	"./Traffic/002-two-ways.png": 2557,
	"./Traffic/003-road-sign.png": 2558,
	"./Traffic/004-barrier.png": 2559,
	"./Traffic/005-right-arrow.png": 2560,
	"./Traffic/006-roundabout.png": 2561,
	"./Traffic/007-prohibition.png": 2562,
	"./Traffic/008-curves.png": 2563,
	"./Traffic/009-intersection-3.png": 2564,
	"./Traffic/010-caravan-1.png": 2565,
	"./Traffic/011-caravan.png": 2566,
	"./Traffic/012-highway.png": 2567,
	"./Traffic/013-traffic-sign-1.png": 2568,
	"./Traffic/014-traffic-sign.png": 2569,
	"./Traffic/015-warning-2.png": 2570,
	"./Traffic/016-gas-station.png": 2571,
	"./Traffic/017-turn-right-2.png": 2572,
	"./Traffic/018-coffee-shop.png": 2573,
	"./Traffic/019-bicycle-1.png": 2574,
	"./Traffic/020-bicycle.png": 2575,
	"./Traffic/021-bump.png": 2576,
	"./Traffic/022-intersection-2.png": 2577,
	"./Traffic/023-turn-1.png": 2578,
	"./Traffic/024-turn-right-1.png": 2579,
	"./Traffic/025-turn-left-1.png": 2580,
	"./Traffic/026-intersection-1.png": 2581,
	"./Traffic/027-intersection.png": 2582,
	"./Traffic/028-waiting.png": 2583,
	"./Traffic/029-horn.png": 2584,
	"./Traffic/030-narrow-road.png": 2585,
	"./Traffic/031-warning-1.png": 2586,
	"./Traffic/032-hill.png": 2587,
	"./Traffic/033-truck.png": 2588,
	"./Traffic/034-pedestrian-2.png": 2589,
	"./Traffic/035-pedestrian-1.png": 2590,
	"./Traffic/036-traffic-light.png": 2591,
	"./Traffic/037-turn.png": 2592,
	"./Traffic/038-slippery.png": 2593,
	"./Traffic/039-no-entry.png": 2594,
	"./Traffic/040-speed-limit.png": 2595,
	"./Traffic/041-humps.png": 2596,
	"./Traffic/042-falling-rocks.png": 2597,
	"./Traffic/043-pedestrian.png": 2598,
	"./Traffic/044-turn-right.png": 2599,
	"./Traffic/045-turn-left.png": 2600,
	"./Traffic/046-u-turn.png": 2601,
	"./Traffic/047-warning.png": 2602,
	"./Traffic/048-no-parking.png": 2603,
	"./Traffic/049-parking.png": 2604,
	"./Traffic/050-danger.png": 2605,
	"./Trailers/BoxTrailer_Black.png": 2606,
	"./Trailers/BoxTrailer_Blue.png": 2607,
	"./Trailers/BoxTrailer_Green.png": 2608,
	"./Trailers/BoxTrailer_Grey.png": 2609,
	"./Trailers/BoxTrailer_Red.png": 2610,
	"./Trailers/BoxTrailer_Yellow.png": 2611,
	"./Trailers/Caravan_Black.png": 2612,
	"./Trailers/Caravan_Blue.png": 2613,
	"./Trailers/Caravan_Green.png": 2614,
	"./Trailers/Caravan_Grey.png": 2615,
	"./Trailers/Caravan_Red.png": 2616,
	"./Trailers/Caravan_Yellow.png": 2617,
	"./Trailers/FullTrailer_Black.png": 2618,
	"./Trailers/FullTrailer_Blue.png": 2619,
	"./Trailers/FullTrailer_Green.png": 2620,
	"./Trailers/FullTrailer_Grey.png": 2621,
	"./Trailers/FullTrailer_Red.png": 2622,
	"./Trailers/FullTrailer_Yellow.png": 2623,
	"./Trailers/SuperSilentGeneratorTrailer_Black.png": 2624,
	"./Trailers/SuperSilentGeneratorTrailer_Blue.png": 2625,
	"./Trailers/SuperSilentGeneratorTrailer_Green.png": 2626,
	"./Trailers/SuperSilentGeneratorTrailer_Grey.png": 2627,
	"./Trailers/SuperSilentGeneratorTrailer_Red.png": 2628,
	"./Trailers/SuperSilentGeneratorTrailer_Yellow.png": 2629,
	"./Trailers/TankerTrailer_Black.png": 2630,
	"./Trailers/TankerTrailer_Blue.png": 2631,
	"./Trailers/TankerTrailer_Green.png": 2632,
	"./Trailers/TankerTrailer_Grey.png": 2633,
	"./Trailers/TankerTrailer_Red.png": 2634,
	"./Trailers/TankerTrailer_Yellow.png": 2635,
	"./Trailers/TravelTrailer_Black.png": 2636,
	"./Trailers/TravelTrailer_Blue.png": 2637,
	"./Trailers/TravelTrailer_Green.png": 2638,
	"./Trailers/TravelTrailer_Grey.png": 2639,
	"./Trailers/TravelTrailer_Red.png": 2640,
	"./Trailers/TravelTrailer_Yellow.png": 2641,
	"./Trailers/WaterBowserTrailer_Black.png": 2642,
	"./Trailers/WaterBowserTrailer_Blue.png": 2643,
	"./Trailers/WaterBowserTrailer_Green.png": 2644,
	"./Trailers/WaterBowserTrailer_Grey.png": 2645,
	"./Trailers/WaterBowserTrailer_Red.png": 2646,
	"./Trailers/WaterBowserTrailer_Yellow.png": 2647,
	"./Transportation/aeroplane.png": 2648,
	"./Transportation/airplane.png": 2649,
	"./Transportation/auto-ricksaw.png": 2650,
	"./Transportation/bike.png": 2651,
	"./Transportation/boat.png": 2652,
	"./Transportation/bus-1.png": 2653,
	"./Transportation/bus.png": 2654,
	"./Transportation/cable-car-cabin.png": 2655,
	"./Transportation/car-1.png": 2656,
	"./Transportation/car-2.png": 2657,
	"./Transportation/car-3.png": 2658,
	"./Transportation/car.png": 2659,
	"./Transportation/catamaran.png": 2660,
	"./Transportation/chairlift.png": 2661,
	"./Transportation/classic-car.png": 2662,
	"./Transportation/helicopter.png": 2663,
	"./Transportation/hot-air-balloon.png": 2664,
	"./Transportation/jeep.png": 2665,
	"./Transportation/locomotive.png": 2666,
	"./Transportation/lorry.png": 2667,
	"./Transportation/minibus.png": 2668,
	"./Transportation/monorail.png": 2669,
	"./Transportation/motorbike.png": 2670,
	"./Transportation/quad.png": 2671,
	"./Transportation/sailboat.png": 2672,
	"./Transportation/sailing-ship.png": 2673,
	"./Transportation/school-bus.png": 2674,
	"./Transportation/ship-1.png": 2675,
	"./Transportation/ship-2.png": 2676,
	"./Transportation/ship-3.png": 2677,
	"./Transportation/ship.png": 2678,
	"./Transportation/sidecar.png": 2679,
	"./Transportation/spaceship.png": 2680,
	"./Transportation/sportive-car.png": 2681,
	"./Transportation/submarine.png": 2682,
	"./Transportation/taxi-1.png": 2683,
	"./Transportation/taxi.png": 2684,
	"./Transportation/tractor.png": 2685,
	"./Transportation/train-1.png": 2686,
	"./Transportation/train-2.png": 2687,
	"./Transportation/train.png": 2688,
	"./Transportation/tram.png": 2689,
	"./Transportation/tricycle.png": 2690,
	"./Transportation/trolleybus.png": 2691,
	"./Transportation/truck.png": 2692,
	"./Transportation/ufo.png": 2693,
	"./Transportation/underground.png": 2694,
	"./Transportation/van-1.png": 2695,
	"./Transportation/van.png": 2696,
	"./Transportation/zeppelin.png": 2697,
	"./Trucks/BinTruck_Black.png": 2698,
	"./Trucks/BinTruck_Blue.png": 2699,
	"./Trucks/BinTruck_Green.png": 2700,
	"./Trucks/BinTruck_Grey.png": 2701,
	"./Trucks/BinTruck_Red.png": 2702,
	"./Trucks/BinTruck_Yellow.png": 2703,
	"./Trucks/FuelTankTruck_Black.png": 2704,
	"./Trucks/FuelTankTruck_Blue.png": 2705,
	"./Trucks/FuelTankTruck_Green.png": 2706,
	"./Trucks/FuelTankTruck_Grey.png": 2707,
	"./Trucks/FuelTankTruck_Red.png": 2708,
	"./Trucks/FuelTankTruck_Yellow.png": 2709,
	"./Trucks/HaulTruck_Black.png": 2710,
	"./Trucks/HaulTruck_Blue.png": 2711,
	"./Trucks/HaulTruck_Green.png": 2712,
	"./Trucks/HaulTruck_Grey.png": 2713,
	"./Trucks/HaulTruck_Red.png": 2714,
	"./Trucks/HaulTruck_Yellow.png": 2715,
	"./Trucks/LorryCab_Black.png": 2716,
	"./Trucks/LorryCab_Blue.png": 2717,
	"./Trucks/LorryCab_Green.png": 2718,
	"./Trucks/LorryCab_Grey.png": 2719,
	"./Trucks/LorryCab_Red.png": 2720,
	"./Trucks/LorryCab_Yellow.png": 2721,
	"./Trucks/LorryTrailer_Black.png": 2722,
	"./Trucks/LorryTrailer_Blue.png": 2723,
	"./Trucks/LorryTrailer_Green.png": 2724,
	"./Trucks/LorryTrailer_Grey.png": 2725,
	"./Trucks/LorryTrailer_Red.png": 2726,
	"./Trucks/LorryTrailer_Yellow.png": 2727,
	"./Trucks/Lorry_Black.png": 2728,
	"./Trucks/Lorry_Blue.png": 2729,
	"./Trucks/Lorry_Green.png": 2730,
	"./Trucks/Lorry_Grey.png": 2731,
	"./Trucks/Lorry_Red.png": 2732,
	"./Trucks/Lorry_Yellow.png": 2733,
	"./Trucks/PetroleumTankTruck_Black.png": 2734,
	"./Trucks/PetroleumTankTruck_Blue.png": 2735,
	"./Trucks/PetroleumTankTruck_Green.png": 2736,
	"./Trucks/PetroleumTankTruck_Grey.png": 2737,
	"./Trucks/PetroleumTankTruck_Red.png": 2738,
	"./Trucks/PetroleumTankTruck_Yellow.png": 2739,
	"./Trucks/SkipTruck_Black.png": 2740,
	"./Trucks/SkipTruck_Blue.png": 2741,
	"./Trucks/SkipTruck_Green.png": 2742,
	"./Trucks/SkipTruck_Grey.png": 2743,
	"./Trucks/SkipTruck_Red.png": 2744,
	"./Trucks/SkipTruck_Yellow.png": 2745,
	"./Trucks/TankerTruck_Black.png": 2746,
	"./Trucks/TankerTruck_Blue.png": 2747,
	"./Trucks/TankerTruck_Green.png": 2748,
	"./Trucks/TankerTruck_Grey.png": 2749,
	"./Trucks/TankerTruck_Red.png": 2750,
	"./Trucks/TankerTruck_Yellow.png": 2751,
	"./Trucks/TractorTrailer2_Black.png": 2752,
	"./Trucks/TractorTrailer2_Blue.png": 2753,
	"./Trucks/TractorTrailer2_Green.png": 2754,
	"./Trucks/TractorTrailer2_Grey.png": 2755,
	"./Trucks/TractorTrailer2_Red.png": 2756,
	"./Trucks/TractorTrailer2_Yellow.png": 2757,
	"./Trucks/TractorTrailer_Black.png": 2758,
	"./Trucks/TractorTrailer_Blue.png": 2759,
	"./Trucks/TractorTrailer_Green.png": 2760,
	"./Trucks/TractorTrailer_Grey.png": 2761,
	"./Trucks/TractorTrailer_Red.png": 2762,
	"./Trucks/TractorTrailer_Yellow.png": 2763,
	"./Trucks/TruckV_Black.png": 2764,
	"./Trucks/TruckV_Blue.png": 2765,
	"./Trucks/TruckV_Green.png": 2766,
	"./Trucks/TruckV_Grey.png": 2767,
	"./Trucks/TruckV_Red.png": 2768,
	"./Trucks/TruckV_Yellow.png": 2769,
	"./Trucks/Truck_Black.png": 2770,
	"./Trucks/Truck_Blue.png": 2771,
	"./Trucks/Truck_Green.png": 2772,
	"./Trucks/Truck_Grey.png": 2773,
	"./Trucks/Truck_Red.png": 2774,
	"./Trucks/Truck_Yellow.png": 2775,
	"./Watercraft/Barge_Black.png": 2776,
	"./Watercraft/Barge_Blue.png": 2777,
	"./Watercraft/Barge_Green.png": 2778,
	"./Watercraft/Barge_Grey.png": 2779,
	"./Watercraft/Barge_Red.png": 2780,
	"./Watercraft/Barge_Yellow.png": 2781,
	"./Watercraft/Boat_Black.png": 2782,
	"./Watercraft/Boat_Blue.png": 2783,
	"./Watercraft/Boat_Gray.png": 2784,
	"./Watercraft/Boat_Green.png": 2785,
	"./Watercraft/Boat_Red.png": 2786,
	"./Watercraft/Boat_Yellow.png": 2787,
	"./Watercraft/BulkCarrier_Black.png": 2788,
	"./Watercraft/BulkCarrier_Blue.png": 2789,
	"./Watercraft/BulkCarrier_Green.png": 2790,
	"./Watercraft/BulkCarrier_Grey.png": 2791,
	"./Watercraft/BulkCarrier_Red.png": 2792,
	"./Watercraft/BulkCarrier_Yellow.png": 2793,
	"./Watercraft/Motorboat_Black.png": 2794,
	"./Watercraft/Motorboat_Blue.png": 2795,
	"./Watercraft/Motorboat_Green.png": 2796,
	"./Watercraft/Motorboat_Grey.png": 2797,
	"./Watercraft/Motorboat_Red.png": 2798,
	"./Watercraft/Motorboat_Yellow.png": 2799,
	"./Watercraft/Sailboat_Black.png": 2800,
	"./Watercraft/Sailboat_Blue.png": 2801,
	"./Watercraft/Sailboat_Green.png": 2802,
	"./Watercraft/Sailboat_Grey.png": 2803,
	"./Watercraft/Sailboat_Red.png": 2804,
	"./Watercraft/Sailboat_Yellow.png": 2805,
	"./Watercraft/Tanker_Black.png": 2806,
	"./Watercraft/Tanker_Blue.png": 2807,
	"./Watercraft/Tanker_Green.png": 2808,
	"./Watercraft/Tanker_Grey.png": 2809,
	"./Watercraft/Tanker_Red.png": 2810,
	"./Watercraft/Tanker_Yellow.png": 2811,
	"./Watercraft/WaterMotorcycle_Black.png": 2812,
	"./Watercraft/WaterMotorcycle_Blue.png": 2813,
	"./Watercraft/WaterMotorcycle_Green.png": 2814,
	"./Watercraft/WaterMotorcycle_Grey.png": 2815,
	"./Watercraft/WaterMotorcycle_Red.png": 2816,
	"./Watercraft/WaterMotorcycle_Yellow.png": 2817
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 51;